import { render } from "./MenuDemo.vue?vue&type=template&id=1e703944"
import script from "./MenuDemo.vue?vue&type=script&lang=js"
export * from "./MenuDemo.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__